import React, { PureComponent } from 'react';
import { Translate, I18n } from 'react-redux-i18n';

class PacksImportResults extends PureComponent {
  render() {
    const { results } = this.props;

    if (!results || !results.length) return null;

    const imported = results.filter(r => r.status === 'imported');
    const skipped = results.filter(r => r.status === 'skipped');

    return (
      <div className="clients-errors">
        <hr />

        {imported.length > 0 && (
          <div>
            <h5 style={{ color: 'green' }}>
              <strong><Translate value="importPacksResultsImportedTitle" /></strong>
            </h5>
            <ul>
              {imported.map(r => (
                <li key={`imported-${r.packIndex}`}>{r.packName}</li>
              ))}
            </ul>
          </div>
        )}

        {skipped.length > 0 && (
          <div>
            <h5 style={{ color: 'red' }}>
              <strong><Translate value="importPacksResultsSkippedTitle" /></strong>
            </h5>
            <ul>
              {skipped.map(r => (
                <li key={`skipped-${r.packIndex}`}>
                  <strong>{r.packName}</strong>
                  {': '}
                  <Translate value={r.messageKey} dangerousHTML />
                  {r.items && r.items.length > 0 && (
                    <ul>
                      {r.items.map((item, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <li key={`${r.packIndex}-${item.code}-${index}`}>
                          {`${item.code} (${I18n.t('line')} ${item.line})`}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

export default PacksImportResults;
